import { KeycloakEvent, KeycloakService } from 'keycloak-angular';
import { Subject } from 'rxjs';

export default {
  getKeycloakInstance: () => {
    return {
      createLoginUrl: () => 'https://test.local/login',
      createRegisterUrl: () => 'https://test.local/registraton',
      createLogoutUrl: () => 'https://test.local/logout',
      tokenParsed: {
        sub: 'test',
        given_name: 'Max',
        family_name: 'Mustermann',
        email: 'max.mustermann@plan.',
        realm_access: {
          roles: [],
        },
      },
    };
  },
  getUserRoles: (_realmRoles?: boolean, _resource?: string) => [],
  isLoggedIn: () => true,
  init: () => new Promise<boolean>(() => true),
  keycloakEvents$: new Subject<KeycloakEvent>(),
} as unknown as KeycloakService;
